import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * A single-tap Sun/Moon button that flips dark_mode on the current theme.
 * Persists via ThemeContext.saveTheme (which writes to the backend & applies
 * to the DOM immediately). Safe to place anywhere in the tree.
 */
export function ThemeQuickToggle({ className = '' }) {
  const { theme, saveTheme, loaded } = useTheme();
  if (!loaded) return null;

  const isDark = !!theme.dark_mode;
  const toggle = () => saveTheme({ ...theme, dark_mode: !isDark });

  return (
    <button
      type="button"
      onClick={toggle}
      className={`inline-flex items-center justify-center h-9 w-9 rounded-sm text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 active:bg-slate-200 dark:active:bg-slate-700 transition-colors ${className}`}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid="theme-quick-toggle"
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}

export default ThemeQuickToggle;
